import { FC, memo } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './styles.module.css';

interface Props {
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  disabled?: boolean;
}

export const ClinicSettingsFilter: FC<Props> = memo(
  ({ onSearch, value, disabled = false }: Props) => {
    return (
      <Input
        allowClear
        className={styles.search}
        placeholder="Поиск по медицинской организации"
        onChange={onSearch}
        value={value}
        prefix={<SearchOutlined className={styles.searchIcon} />}
        style={{ fontSize: 14 }}
        disabled={disabled}
      />
    );
  },
);

ClinicSettingsFilter.displayName = 'ClinicSettingsFilter';
